/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useContext } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { MyPopup } from '@/components/_common/StyledPopup';
import PolicyContext from '../../components/PolicyContext';
import { PolicyEditContext } from '../../policy';

const scrollbarStyle = { height: '100%', minHeight: '400px' }
const scrollbarContentStyle = { marginRight: '10px' }
function KycRead() {
  const { popup } = useContext(PolicyContext as React.Context<PolicyEditContext>);
  return (
    <MyPopup
      trigger={<a className="text-primary h5">消費者網路投保需求聲明事項(KYC)</a>}
      modal
      size="lg"
    >
      <div>
        <h5 className="title-line-secondary">消費者網路投保需求聲明事項(kyc)</h5>
      </div>
      <Scrollbars className="text-gray" style={scrollbarStyle}>
        <div style={scrollbarContentStyle} dangerouslySetInnerHTML={{ __html: popup.kycRead }} />
      </Scrollbars>
    </MyPopup>
  );
}

export default KycRead;
